import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { supplierGroupsQueryOptions } from '../../../../features/suppliers/queries'
import { EditSupplierPage } from '../../../../features/suppliers/supplier-edit-pages'

export const Route = createFileRoute('/_app/suppliers/$supplierId/edit')({
  staticData: { crumb: 'supplierEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'suppliers.update'),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(supplierGroupsQueryOptions)
  },
  component: EditSupplierPage,
})
